import { createSelector } from 'reselect';
import { AppState } from '../../types';
import { User } from '../user/types';

const defaultUser: User = {
    id: 0,
    name: '',
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    supervisors: [],
    allUsers: [],
    leaveTypes: [],
    isSupervisor: false,
};

export const authSelector = ({ auth }: AppState) => auth;
export const authUserSelector = createSelector(
    authSelector,
    ({ user }: { user?: User } = {}) => user,
);
export const authUserWithDefaultsSelector = createSelector(
    authUserSelector,
    (user?: User): User => {
        if (user) {
            return user;
        }

        return defaultUser;
    },
);

export const authPendingSelector = createSelector(
    authSelector,
    ({ pending }: { pending: boolean } = { pending: true }) => pending,
);
